import React from "react";

function specialityExcelCell(options, column, gridCell) {
    if (gridCell.value) {
        options.value = (gridCell.data[column.dataField + "_code"] || "")
            + "  "
            + (gridCell.data[column.dataField + "_name"] || "");
    }
}

function specialityCell(config, columnSpec) {
    let prefix = columnSpec.dataField;
    let codeField = prefix + "_code";
    let nameField = prefix + "_name";
    config.dataType = "string";
    config.calculateCellValue = (row) => {
        return (row[codeField] || "") + " " + (row[nameField] || "");
    }
}

export {specialityCell, specialityExcelCell}
